import axios from 'axios';

class ServiceNextProjectController {
  async listProjects() {
    const response = await axios.get('/api/next-project/projects');
    return response.data;
  }

  async importProjects(ids: number[]) {
    const response = await axios.post('/api/next-project/import', { ids });
    return response.data;
  }

  async exportProject(projectId: string, parentProjectId?: number, parentCustomerId?: number) {
    const response = await axios.post('/api/next-project/export', { projectId, parentProjectId, parentCustomerId });
    return response.data;
  }

  async listCustomers() {
    const response = await axios.get('/api/next-project/customers');
    return response.data;
  }

  async checkCustomerExists(customerId: number) {
    const response = await axios.get(`/api/next-project/customers/${customerId}`);
    return response.data;
  }
}

export const ServiceNextProject = new ServiceNextProjectController();